import React, {useEffect, useCallback, useState} from "react";
import FiltersSection from '../components/sections/filters';
import { useDispatch, useSelector } from "react-redux";
import { changeDimension, changeFilter, changePublisherView, getTrends } from '../stateManagement/actions/report';
import Loader from '../components/layout/loader';
import { biaxialChartPreparation } from "../services/dataHandling";
import { useAuth } from "../hooks/useAuth";
import { ADMIN_ACCESS, PARTITION_MAIN, PARTITION_THD } from "../utils/constants";
import BiaxialChart from "../components/charts/biaxialChart";
import { useLocation } from "react-router-dom";


const TrendsPage = () => {
    
    //Prepare dispatcher
    const dispatch = useDispatch();
    
    //API data prep
    const [fullReport, setFullReport] = useState({current: [], reference: []});
    
    //Chart data prep
    const [chartData, setChartData] = useState([]);
    const [dataReloaded, setDataReloaded] = useState(false);

    //Get required data from global state
    const {user} = useAuth();
    const reportData = useSelector((state) => state.reportReducer);
    const {loading, period, filterBy, publisherView} = reportData;
    const location = useLocation();
    const PARTITION = location.pathname.includes(PARTITION_THD) ? PARTITION_THD : PARTITION_MAIN;

    //Initial filters reset
    useEffect(()=>{
        dispatch(changeFilter(''));
        dispatch(changeDimension(''));
    }, [dispatch]);

    //Load view mode
    useEffect(()=>{
        if(user && user.access && !publisherView){
            const accessList = user.access.split('+');
            dispatch(changePublisherView(accessList[0] === ADMIN_ACCESS ? 'Gemius' : accessList[0]));
        }
    }, [dispatch, user, publisherView])

    //Store API response until something is changed
    const getResources = useCallback(()=>{
        dispatch(
            getTrends(
                {period, filterBy, publisherView, partition: PARTITION}, 
                setFullReport, 
                setDataReloaded
            ));
    }, [dispatch, period, filterBy, publisherView, PARTITION]);


    //Load resources from API
    useEffect(()=>{
        getResources()
    }, [getResources]);
    
    //Prep chart data once API data is loaded/reloaded
    useEffect(() => {
        if(dataReloaded){
            const computedData = biaxialChartPreparation(fullReport, period);
            setChartData(computedData);
        }
    // eslint-disable-next-line
    }, [fullReport, dataReloaded]);

    if (loading) {return <Loader />}
    
    return (
        <>
            <h2>{`Trends for ${publisherView} account`}</h2>
            <FiltersSection limited={true}/>
            <BiaxialChart fullData={chartData}/>
        </>
    );
}

export default TrendsPage;